import { Component, OnDestroy, OnInit } from '@angular/core'

import { ActivatedRoute, Router } from '@angular/router'
import { SubscriptionLike, from } from 'rxjs'
import { AgentModel } from 'src/app/models/agent.model'
import { Client } from 'src/app/models/client.model'
 

import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service'


@Component({
  selector: 'app-client-info',
  templateUrl: './client-info.component.html',
  styleUrls: ['./client-info.component.scss']
})
export class ClientInfoComponent implements OnInit, OnDestroy {
  public id = ''

  public buypoint: Client | undefined

  public loading = true
  public error = false
  agent: AgentModel | undefined
  isAdmin = false


  tabindex = 0

  subscriptions: SubscriptionLike[] = []
  ignoreFirst = 0
  priceTypes: { [key: string]: string } | undefined


  constructor(
    private route: ActivatedRoute,
    public cm: ConnectionManagerService,

    private router: Router
  ) {

    this.isAdmin = cm.isAdmin()
  }

  ngOnInit(): void {

    const sub1 = this.cm.activeServerObservable().subscribe(x => { this.ignoreFirst++; if (this.ignoreFirst > 1) { this.router.navigate(['/home']) } })

    const sub2 = this.route.paramMap.subscribe((params) => {
      this.id = params.get('id') as string
      this.getClientDb()


    })



    this.subscriptions.push(sub2)
    this.subscriptions.push(sub1)
  }

  pricetypeName(code: string): string | undefined {
    if (!this.priceTypes) {
      return ""
    }

    return this.priceTypes[code];
  }

  getClientDb() {
    this.loading = true

    from(this.cm.getDb()).subscribe((db) => {
      if (!db) return



      db.getClient(this.id).subscribe(bp => {
        this.buypoint = bp
        this.loading = false

        if (this.cm.activeServer?.agent.Server) {
          const list = db.priceTypes[this.cm.activeServer.agent.Server]
          this.priceTypes = {}

          list.forEach(p => {
            if (this.priceTypes) {
              this.priceTypes[p.code] = p.name
            }
          })

        }
      })
    })


  }



  reload() {
    //

  }


  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe())
    this.subscriptions = []

  }
}
